module.exports = __webpack_public_path__ + "static/media/map_pin.43438db5.svg";